import type { FaireProductEntity } from "../../entity_types/product";

export const p_6u2zz7z67y: FaireProductEntity = {
  token: "p_6u2zz7z67y",
  type: "product",
  name: "Royal Ducklings 230gsm Bamboo Zippy Pajama",
  brandToken: "b_7tyz7uw3es",
  brandName: "The Honey and Bro Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e9bc86fef5ee9a2c582d68ab604d9acb3bf61cd32f94039fa13c544472f3b58e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/172a8fb4a22708ba8b92a69055c4624a36f187acc8808f04f25c7175b7673401.png",
  ],
  priceDollars: 19,
  description:
    "The softest 230GSM bamboo baby pajamas in our adorable Royal Ducklings print! Sweet little ducklings wearing flower crowns and pink rain boots splash through puddles with pink umbrellas — an original H&B design your customers will fall in love with.\n\n* SWEET DREAMS: Made from our premium 230gsm bamboo — noticeably thicker and more luxurious than the 180-220gsm bamboo used by most brands. Our buttery soft bamboo/spandex blend has the perfect amount of stretch for the most comfortable sleep. Gets softer with every wash — a proven repeat purchase driver for retailers.\n\n* FEATURES: Our two-way YKK zipper design makes late night changes a breeze. Convertible fold-over foot cuffs to keep toes warm or bare for warmer nights. Fold-over mitten cuffs on NB, 0-3M, 3-6M to prevent scratching. Neckline zipper guard for protection. Pink trim details. Digital sublimation print — vibrant colors that won't fade.\n\nDetails\n• Made in China\n• Care: Machine wash cold, gentle cycle. Tumble dry low. Do not bleach. Do not iron on print.\n• Fabric: 95% Bamboo Viscose / 5% Spandex\n• Weight: 230gsm (premium)\n• Certification: OEKO-TEX Standard 100\n• Sizes: NB, 0-3M, 3-6M, 6-12M, 12-18M\n\nDesigned in New Jersey by The Honey and Bro Co.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:30.773Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
